jQuery( document ).ready( function($) {
		function JTFCAROUSEL_AUTOSLIDE( thisInstance ) {
			console.log('JTF CAROUSEL - AUTO SCROLL ACTIVATED');
			this.init( thisInstance );
		}
		/**
		 * Function to set the event listeners and interval duration
		 *
		 * @param thisInstance
		 */
		JTFCAROUSEL_AUTOSLIDE.prototype.init = function ( thisInstance ) {
			const self = this;
			// Set the time interval (e.g every 5 seconds)
			const interval = setInterval(
				function () {
					self.loadCarousel( thisInstance );
				},
				5000
			);
			// Stop the auto-scroll when mouse enters the carousel
			$( thisInstance ).mouseenter(
				function () {
					console.log('JTF CAROUSEL - AUTO SCROLL DEACTIVATED');
					clearInterval( interval );
				}
			);
		}
		/**
		 * Function to initiate the auto-scrolling of the carousel
		 *
		 * @param thisInstance
		 */
		JTFCAROUSEL_AUTOSLIDE.prototype.loadCarousel = function ( thisInstance ) {
			const self   = this;
			// Interface bindings
			const parent = thisInstance.find( '.jtf__carouselblock--container' );
			let position = parent.attr('data-position');
			let inner    = thisInstance.find( '.jtf__carouselblock--inner' ).attr( 'data-children' );
			let prev     = thisInstance.find( '.jtf__carouselblock--prev' );
			// Remove the inactive state
			prev.removeClass( 'jtf__carouselblock--navigation-inactive' );
			// Manage the carousel state
			if ( ( parseInt( position ) + 1 ) < parseInt( inner ) ) {
				parent.attr('data-position', parseInt( position ) + 1 )
				self.setActiveDot( parseInt( position ) + 1 );
				self.navigateCarousel( thisInstance );
			} else {
				prev.addClass('jtf__carouselblock--navigation-inactive')
				parent.attr('data-position', 0 )
				self.setActiveDot( 0 );
				self.navigateCarousel( thisInstance );
			}
		}
		/**
		 * Function to move the selector to a new slide (requires parent and inner for calcs)
		 *
		 * @param thisInstance
		 */
		JTFCAROUSEL_AUTOSLIDE.prototype.navigateCarousel = function ( thisInstance ) {
			// Interface bindings
			const inner = thisInstance.find( '.jtf__carouselblock--inner' );
			const position = thisInstance.find( '.jtf__carouselblock--container' ).attr( 'data-position' )
			const innerChildren = thisInstance.find( '.jtf__carouselblock--inner' ).attr('data-children' )
			// Control the movement for the standard versus the timeline carousel
			if ( thisInstance.find( '.jtf__carouselblock--timeline' ).length > 0 ) {
				let childWidth = ( inner.width() / innerChildren )
				inner.css(
					{
						'transform': 'translateX( -'+( childWidth * position ) + 'px)',
						'transition-duration': '1s'
					}
				)
			} else {
				inner.css(
					{
						'transform': 'translateX(-'+( inner.width() * position )+'px)',
						'transition-duration': '1s'
					}
				)
			}
		}
		/**
		 * Sets which dot is currently active, resets the state on the others
		 *
		 * @param active
		 */
		JTFCAROUSEL_AUTOSLIDE.prototype.setActiveDot = function ( active ) {
			// Remove the active dot
			$( document ).find( '.jtf__carouselblock--dot-active' ).removeClass( 'jtf__carouselblock--dot-active' );
			// Set the new active dot
			$( document ).find( '.jtf__carouselblock--dot' ).each(
				function() {
					if ( parseInt( $( this ).attr( 'data-target' ) ) == parseInt( active ) ) {
						// console.log( parseInt( $(this).attr( 'data-target' ) ), parseInt( active ) )
						$( this ).addClass( 'jtf__carouselblock--dot-active' );
					}
				}
			);
		}
		/*
		 * If carousel is on homepage then activate auto-slide
		 */
		const classCarousel = $( '.wp-block-jtf-jtf-carousel' );
		if ( $( classCarousel ).length > 0 && $( '.home' ).length > 0 ) {
			// Instantiate auto-slide
			const jtfcarousel = new JTFCAROUSEL_AUTOSLIDE( classCarousel );
		}
	}
);